/* tslint:disable */
/* eslint-disable */
/**
 * MWS.IdentityService.WebApp | v2-admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AdminCognitoAttribute {
    'name': string;
    'value': string | null;
}
export interface AdminCognitoUser {
    'username': string;
    'userStatus': string | null;
    'enabled': boolean;
    'userCreateDate': Date | null;
    'userLastModifiedDate': Date | null;
    'preferredMfaSetting': string | null;
    'userMfaSettingList': Array<string>;
    'attributes': Array<AdminCognitoAttribute>;
}
export interface AdminCognitoUsers {
    'email': string;
    'userPoolId': string;
    'users': Array<AdminCognitoUser>;
}
export interface AdminListUser {
    'id': string;
    'platformId': string;
    'email': string;
    'registrationDate': Date;
    'firstName': string | null;
    'lastName': string | null;
    'phoneNumber': string | null;
    'countryCode': string | null;
    'identityProviders': Array<string>;
    'isDeleted': boolean;
    'suspensionStatus': SuspensionStatus;
}


export interface AdminListUserList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminListUser>;
}
export interface AdminSetUserPhoneRequest {
    'phoneNumber': string;
}
export interface AdminUser {
    'id': string;
    'platformId': string;
    'dateCreated': Date;
    'email': string;
    'emailVerified': boolean;
    'phoneNumber': string | null;
    'phoneNumberCountryCode': string | null;
    'phoneNumberVerified': boolean;
    'addressVerified': boolean;
    'paymentVerified': boolean;
    'idVerified': boolean;
    'requirePasswordReset': boolean;
    'softDeleted': boolean;
    'roles': Array<RoleDto>;
    'identityProviders': Array<string>;
    'suspensionStatus': SuspensionStatus;
    'permissions': Array<string>;
}


export interface CreateAdminAccountRequest {
    'email': string;
    'password': string | null;
}
export interface DeleteOutboxMessages {
    'deletedCount': number;
}
export interface DeleteOutboxMessagesRequest {
    'ids': Array<string>;
}
export interface ErrorFailuresInner {
    'errorCode': string;
    'errorMessage': string;
    'propertyName': string;
}
export interface ModelError {
    'code': string;
    'message': string;
    'failures': Array<ErrorFailuresInner> | null;
}
export interface OutboxFailedHandler {
    'name': string;
}
export interface OutboxMessage {
    'id': string;
    'type': string;
    'state': OutboxMessageState;
    'timestamp': Date;
    'dateCreated': Date;
    'retryCount': number;
    'traceId': string | null;
    'spanId': string | null;
    'userId': string | null;
    'platformId': string | null;
    'version': string;
    'failedHandlers': Array<OutboxFailedHandler>;
    'payload': any;
}


export interface OutboxMessageList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<OutboxMessage>;
}

export enum OutboxMessageState {
    Created = 'created',
    Published = 'published',
    Failed = 'failed'
}


export interface ResetOutboxMessages {
    'updatedCount': number;
}
export interface ResetOutboxMessagesRequest {
    'ids': Array<string>;
}
export interface RoleDto {
    'id': string;
    'name': string | null;
    'description': string | null;
    'permissions': Array<string> | null;
}
export interface SetUserRolesRequestDto {
    'roles': Array<string> | null;
}

export enum SuspensionStatus {
    NotSuspended = 'not_suspended',
    SoftSuspended = 'soft_suspended',
    HardSuspended = 'hard_suspended'
}



/**
 * AdminOutboxMessagesApi - axios parameter creator
 */
export const AdminOutboxMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeleteOutboxMessagesRequest} deleteOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminIdentityOutboxMessagesDeleteDelete: async (deleteOutboxMessagesRequest: DeleteOutboxMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteOutboxMessagesRequest' is not null or undefined
            assertParamExists('v2AdminIdentityOutboxMessagesDeleteDelete', 'deleteOutboxMessagesRequest', deleteOutboxMessagesRequest)
            const localVarPath = `/v2/admin/identity-outbox-messages/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = deleteOutboxMessagesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OutboxMessageState} [status] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminIdentityOutboxMessagesGet: async (status?: OutboxMessageState, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/identity-outbox-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetOutboxMessagesRequest} resetOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminIdentityOutboxMessagesResetPatch: async (resetOutboxMessagesRequest: ResetOutboxMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetOutboxMessagesRequest' is not null or undefined
            assertParamExists('v2AdminIdentityOutboxMessagesResetPatch', 'resetOutboxMessagesRequest', resetOutboxMessagesRequest)
            const localVarPath = `/v2/admin/identity-outbox-messages/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = resetOutboxMessagesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOutboxMessagesApi - functional programming interface
 */
export const AdminOutboxMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOutboxMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeleteOutboxMessagesRequest} deleteOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminIdentityOutboxMessagesDeleteDelete(deleteOutboxMessagesRequest: DeleteOutboxMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOutboxMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminIdentityOutboxMessagesDeleteDelete(deleteOutboxMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOutboxMessagesApi.v2AdminIdentityOutboxMessagesDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OutboxMessageState} [status] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminIdentityOutboxMessagesGet(status?: OutboxMessageState, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboxMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminIdentityOutboxMessagesGet(status, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOutboxMessagesApi.v2AdminIdentityOutboxMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetOutboxMessagesRequest} resetOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminIdentityOutboxMessagesResetPatch(resetOutboxMessagesRequest: ResetOutboxMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetOutboxMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminIdentityOutboxMessagesResetPatch(resetOutboxMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOutboxMessagesApi.v2AdminIdentityOutboxMessagesResetPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOutboxMessagesApi - factory interface
 */
export const AdminOutboxMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOutboxMessagesApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminIdentityOutboxMessagesDeleteDelete(requestParameters: AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOutboxMessages> {
            return localVarFp.v2AdminIdentityOutboxMessagesDeleteDelete(requestParameters.deleteOutboxMessagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminIdentityOutboxMessagesGet(requestParameters: AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OutboxMessageList> {
            return localVarFp.v2AdminIdentityOutboxMessagesGet(requestParameters.status, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesResetPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminIdentityOutboxMessagesResetPatch(requestParameters: AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesResetPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetOutboxMessages> {
            return localVarFp.v2AdminIdentityOutboxMessagesResetPatch(requestParameters.resetOutboxMessagesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminIdentityOutboxMessagesDeleteDelete operation in AdminOutboxMessagesApi.
 */
export interface AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesDeleteDeleteRequest {
    readonly deleteOutboxMessagesRequest: DeleteOutboxMessagesRequest
}

/**
 * Request parameters for v2AdminIdentityOutboxMessagesGet operation in AdminOutboxMessagesApi.
 */
export interface AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesGetRequest {
    readonly status?: OutboxMessageState

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2AdminIdentityOutboxMessagesResetPatch operation in AdminOutboxMessagesApi.
 */
export interface AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesResetPatchRequest {
    readonly resetOutboxMessagesRequest: ResetOutboxMessagesRequest
}

/**
 * AdminOutboxMessagesApi - object-oriented interface
 */
export class AdminOutboxMessagesApi extends BaseAPI {
    /**
     * 
     * @param {AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminIdentityOutboxMessagesDeleteDelete(requestParameters: AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminOutboxMessagesApiFp(this.configuration).v2AdminIdentityOutboxMessagesDeleteDelete(requestParameters.deleteOutboxMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminIdentityOutboxMessagesGet(requestParameters: AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOutboxMessagesApiFp(this.configuration).v2AdminIdentityOutboxMessagesGet(requestParameters.status, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesResetPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminIdentityOutboxMessagesResetPatch(requestParameters: AdminOutboxMessagesApiV2AdminIdentityOutboxMessagesResetPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOutboxMessagesApiFp(this.configuration).v2AdminIdentityOutboxMessagesResetPatch(requestParameters.resetOutboxMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminUsersApi - axios parameter creator
 */
export const AdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search Users endpoint.
         * @param {string} [searchTerm] Will be used to search based on E-mail address and Phone Number
         * @param {number} [offset] 
         * @param {number} [size] 
         * @param {Array<string>} [roleIds] 
         * @param {Array<string>} [searchTerms] When provided, returns users matching ANY of the supplied terms (OR semantics) against E-mail and Phone Number
         * @param {string} [xPlatformKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersGet: async (searchTerm?: string, offset?: number, size?: number, roleIds?: Array<string>, searchTerms?: Array<string>, xPlatformKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (roleIds) {
                localVarQueryParameter['role_ids'] = roleIds;
            }

            if (searchTerms) {
                localVarQueryParameter['search_terms'] = searchTerms;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the currently logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAdminAccountRequest} createAdminAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersPost: async (createAdminAccountRequest: CreateAdminAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdminAccountRequest' is not null or undefined
            assertParamExists('v2AdminUsersPost', 'createAdminAccountRequest', createAdminAccountRequest)
            const localVarPath = `/v2/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createAdminAccountRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [dev] Returns the raw Cognito user records linked to this user (by email). May return multiple records when the user has linked external identity providers.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdCognitoGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdCognitoGet', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/cognito`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdDelete: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdDelete', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a single User.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdGet', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft suspends a User so they can only see the orders page on our platform.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdHardSuspendPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdHardSuspendPatch', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/hard-suspend`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdIdVerificationPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdIdVerificationPatch', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/id-verification`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Send a password reset email to a user <param name=\"force\">Force the user to reset its password</param> <param name=\"_\">A Cancellation token.</param>
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdPasswordResetPost: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdPasswordResetPost', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/password/reset`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Update the users phone number <param name=\"userId\">The user ID.</param> <param name=\"request\">The email address and phone number. </param> <param name=\"_\">A Cancellation token.</param>
         * @param {string} userId 
         * @param {AdminSetUserPhoneRequest} adminSetUserPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdPhonePatch: async (userId: string, adminSetUserPhoneRequest: AdminSetUserPhoneRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdPhonePatch', 'userId', userId)
            // verify required parameter 'adminSetUserPhoneRequest' is not null or undefined
            assertParamExists('v2AdminUsersUserIdPhonePatch', 'adminSetUserPhoneRequest', adminSetUserPhoneRequest)
            const localVarPath = `/v2/admin/users/{userId}/phone`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = adminSetUserPhoneRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Updates the user identified by {userId} to have the specified roles.
         * @param {string} userId 
         * @param {SetUserRolesRequestDto} setUserRolesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdRolesPut: async (userId: string, setUserRolesRequestDto: SetUserRolesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdRolesPut', 'userId', userId)
            // verify required parameter 'setUserRolesRequestDto' is not null or undefined
            assertParamExists('v2AdminUsersUserIdRolesPut', 'setUserRolesRequestDto', setUserRolesRequestDto)
            const localVarPath = `/v2/admin/users/{userId}/roles`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = setUserRolesRequestDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft suspends a User so they can only see the orders page on our platform.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdSoftSuspendPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdSoftSuspendPatch', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/soft-suspend`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unsuspends a User so they can login again.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdUnsuspendPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdUnsuspendPatch', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/unsuspend`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets a user\'s payment verification status to verified
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdVerificationPaymentVerifiedPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminUsersUserIdVerificationPaymentVerifiedPatch', 'userId', userId)
            const localVarPath = `/v2/admin/users/{userId}/verification/payment/verified`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUsersApi - functional programming interface
 */
export const AdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search Users endpoint.
         * @param {string} [searchTerm] Will be used to search based on E-mail address and Phone Number
         * @param {number} [offset] 
         * @param {number} [size] 
         * @param {Array<string>} [roleIds] 
         * @param {Array<string>} [searchTerms] When provided, returns users matching ANY of the supplied terms (OR semantics) against E-mail and Phone Number
         * @param {string} [xPlatformKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersGet(searchTerm?: string, offset?: number, size?: number, roleIds?: Array<string>, searchTerms?: Array<string>, xPlatformKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminListUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersGet(searchTerm, offset, size, roleIds, searchTerms, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the currently logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAdminAccountRequest} createAdminAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersPost(createAdminAccountRequest: CreateAdminAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersPost(createAdminAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [dev] Returns the raw Cognito user records linked to this user (by email). May return multiple records when the user has linked external identity providers.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdCognitoGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCognitoUsers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdCognitoGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdCognitoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdDelete(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdDelete(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a single User.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft suspends a User so they can only see the orders page on our platform.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdHardSuspendPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdHardSuspendPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdHardSuspendPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdIdVerificationPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdIdVerificationPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdIdVerificationPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Send a password reset email to a user <param name=\"force\">Force the user to reset its password</param> <param name=\"_\">A Cancellation token.</param>
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdPasswordResetPost(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdPasswordResetPost(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Update the users phone number <param name=\"userId\">The user ID.</param> <param name=\"request\">The email address and phone number. </param> <param name=\"_\">A Cancellation token.</param>
         * @param {string} userId 
         * @param {AdminSetUserPhoneRequest} adminSetUserPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdPhonePatch(userId: string, adminSetUserPhoneRequest: AdminSetUserPhoneRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdPhonePatch(userId, adminSetUserPhoneRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdPhonePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Updates the user identified by {userId} to have the specified roles.
         * @param {string} userId 
         * @param {SetUserRolesRequestDto} setUserRolesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdRolesPut(userId: string, setUserRolesRequestDto: SetUserRolesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdRolesPut(userId, setUserRolesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdRolesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft suspends a User so they can only see the orders page on our platform.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdSoftSuspendPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdSoftSuspendPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdSoftSuspendPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unsuspends a User so they can login again.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdUnsuspendPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdUnsuspendPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdUnsuspendPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sets a user\'s payment verification status to verified
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminUsersUserIdVerificationPaymentVerifiedPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminUsersUserIdVerificationPaymentVerifiedPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.v2AdminUsersUserIdVerificationPaymentVerifiedPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUsersApi - factory interface
 */
export const AdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Search Users endpoint.
         * @param {AdminUsersApiV2AdminUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersGet(requestParameters: AdminUsersApiV2AdminUsersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminListUserList> {
            return localVarFp.v2AdminUsersGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.size, requestParameters.roleIds, requestParameters.searchTerms, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the currently logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersMeGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminUser> {
            return localVarFp.v2AdminUsersMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUsersApiV2AdminUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersPost(requestParameters: AdminUsersApiV2AdminUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersPost(requestParameters.createAdminAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [dev] Returns the raw Cognito user records linked to this user (by email). May return multiple records when the user has linked external identity providers.
         * @param {AdminUsersApiV2AdminUsersUserIdCognitoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdCognitoGet(requestParameters: AdminUsersApiV2AdminUsersUserIdCognitoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCognitoUsers> {
            return localVarFp.v2AdminUsersUserIdCognitoGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
         * @param {AdminUsersApiV2AdminUsersUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdDelete(requestParameters: AdminUsersApiV2AdminUsersUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdDelete(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a single User.
         * @param {AdminUsersApiV2AdminUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdGet(requestParameters: AdminUsersApiV2AdminUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUser> {
            return localVarFp.v2AdminUsersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft suspends a User so they can only see the orders page on our platform.
         * @param {AdminUsersApiV2AdminUsersUserIdHardSuspendPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdHardSuspendPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdHardSuspendPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdHardSuspendPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUsersApiV2AdminUsersUserIdIdVerificationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdIdVerificationPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdIdVerificationPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdIdVerificationPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Send a password reset email to a user <param name=\"force\">Force the user to reset its password</param> <param name=\"_\">A Cancellation token.</param>
         * @param {AdminUsersApiV2AdminUsersUserIdPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdPasswordResetPost(requestParameters: AdminUsersApiV2AdminUsersUserIdPasswordResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdPasswordResetPost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Update the users phone number <param name=\"userId\">The user ID.</param> <param name=\"request\">The email address and phone number. </param> <param name=\"_\">A Cancellation token.</param>
         * @param {AdminUsersApiV2AdminUsersUserIdPhonePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdPhonePatch(requestParameters: AdminUsersApiV2AdminUsersUserIdPhonePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdPhonePatch(requestParameters.userId, requestParameters.adminSetUserPhoneRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Updates the user identified by {userId} to have the specified roles.
         * @param {AdminUsersApiV2AdminUsersUserIdRolesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdRolesPut(requestParameters: AdminUsersApiV2AdminUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdRolesPut(requestParameters.userId, requestParameters.setUserRolesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft suspends a User so they can only see the orders page on our platform.
         * @param {AdminUsersApiV2AdminUsersUserIdSoftSuspendPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdSoftSuspendPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdSoftSuspendPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdSoftSuspendPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unsuspends a User so they can login again.
         * @param {AdminUsersApiV2AdminUsersUserIdUnsuspendPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdUnsuspendPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdUnsuspendPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdUnsuspendPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets a user\'s payment verification status to verified
         * @param {AdminUsersApiV2AdminUsersUserIdVerificationPaymentVerifiedPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdVerificationPaymentVerifiedPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminUsersGet operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersGetRequest {
    /**
     * Will be used to search based on E-mail address and Phone Number
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly size?: number

    readonly roleIds?: Array<string>

    /**
     * When provided, returns users matching ANY of the supplied terms (OR semantics) against E-mail and Phone Number
     */
    readonly searchTerms?: Array<string>

    readonly xPlatformKey?: string
}

/**
 * Request parameters for v2AdminUsersPost operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersPostRequest {
    readonly createAdminAccountRequest: CreateAdminAccountRequest
}

/**
 * Request parameters for v2AdminUsersUserIdCognitoGet operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdCognitoGetRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdDelete operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdDeleteRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdGet operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdGetRequest {
    /**
     * 
     */
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdHardSuspendPatch operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdHardSuspendPatchRequest {
    /**
     * 
     */
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdIdVerificationPatch operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdIdVerificationPatchRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdPasswordResetPost operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdPasswordResetPostRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdPhonePatch operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdPhonePatchRequest {
    readonly userId: string

    readonly adminSetUserPhoneRequest: AdminSetUserPhoneRequest
}

/**
 * Request parameters for v2AdminUsersUserIdRolesPut operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdRolesPutRequest {
    readonly userId: string

    readonly setUserRolesRequestDto: SetUserRolesRequestDto
}

/**
 * Request parameters for v2AdminUsersUserIdSoftSuspendPatch operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdSoftSuspendPatchRequest {
    /**
     * 
     */
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdUnsuspendPatch operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdUnsuspendPatchRequest {
    /**
     * 
     */
    readonly userId: string
}

/**
 * Request parameters for v2AdminUsersUserIdVerificationPaymentVerifiedPatch operation in AdminUsersApi.
 */
export interface AdminUsersApiV2AdminUsersUserIdVerificationPaymentVerifiedPatchRequest {
    readonly userId: string
}

/**
 * AdminUsersApi - object-oriented interface
 */
export class AdminUsersApi extends BaseAPI {
    /**
     * 
     * @summary Search Users endpoint.
     * @param {AdminUsersApiV2AdminUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersGet(requestParameters: AdminUsersApiV2AdminUsersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.size, requestParameters.roleIds, requestParameters.searchTerms, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the currently logged in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersMeGet(options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUsersApiV2AdminUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersPost(requestParameters: AdminUsersApiV2AdminUsersPostRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersPost(requestParameters.createAdminAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [dev] Returns the raw Cognito user records linked to this user (by email). May return multiple records when the user has linked external identity providers.
     * @param {AdminUsersApiV2AdminUsersUserIdCognitoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdCognitoGet(requestParameters: AdminUsersApiV2AdminUsersUserIdCognitoGetRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdCognitoGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
     * @param {AdminUsersApiV2AdminUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdDelete(requestParameters: AdminUsersApiV2AdminUsersUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdDelete(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a single User.
     * @param {AdminUsersApiV2AdminUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdGet(requestParameters: AdminUsersApiV2AdminUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft suspends a User so they can only see the orders page on our platform.
     * @param {AdminUsersApiV2AdminUsersUserIdHardSuspendPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdHardSuspendPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdHardSuspendPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdHardSuspendPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUsersApiV2AdminUsersUserIdIdVerificationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdIdVerificationPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdIdVerificationPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdIdVerificationPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Send a password reset email to a user <param name=\"force\">Force the user to reset its password</param> <param name=\"_\">A Cancellation token.</param>
     * @param {AdminUsersApiV2AdminUsersUserIdPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdPasswordResetPost(requestParameters: AdminUsersApiV2AdminUsersUserIdPasswordResetPostRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdPasswordResetPost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Update the users phone number <param name=\"userId\">The user ID.</param> <param name=\"request\">The email address and phone number. </param> <param name=\"_\">A Cancellation token.</param>
     * @param {AdminUsersApiV2AdminUsersUserIdPhonePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdPhonePatch(requestParameters: AdminUsersApiV2AdminUsersUserIdPhonePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdPhonePatch(requestParameters.userId, requestParameters.adminSetUserPhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Updates the user identified by {userId} to have the specified roles.
     * @param {AdminUsersApiV2AdminUsersUserIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdRolesPut(requestParameters: AdminUsersApiV2AdminUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdRolesPut(requestParameters.userId, requestParameters.setUserRolesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft suspends a User so they can only see the orders page on our platform.
     * @param {AdminUsersApiV2AdminUsersUserIdSoftSuspendPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdSoftSuspendPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdSoftSuspendPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdSoftSuspendPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unsuspends a User so they can login again.
     * @param {AdminUsersApiV2AdminUsersUserIdUnsuspendPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdUnsuspendPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdUnsuspendPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdUnsuspendPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets a user\'s payment verification status to verified
     * @param {AdminUsersApiV2AdminUsersUserIdVerificationPaymentVerifiedPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters: AdminUsersApiV2AdminUsersUserIdVerificationPaymentVerifiedPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).v2AdminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



